import React, { FC, useMemo } from 'react';
import type { ColumnsType } from 'antd/es/table';

import { securableTypes } from '../../../../../constants';
import { IRoleType } from '../../../../../models/types';

import FormAntSwitch from '../FormAntSwitch';
import { renderToggleCell, toggleColumnProps } from '../permissionsTableColumns';
import ScrollablePermissionsTable from '../ScrollablePermissionsTable';

import '../PermissionsTable.css';

export interface IProps {
  treeItem: string;
  list: string[];
  roles: IRoleType[];
}

const List: FC<IProps> = ({ list, treeItem, roles }) => {
  const columns: ColumnsType<IRoleType> = useMemo(
    () => [
      {
        title: 'Роль',
        dataIndex: 'friendlyName',
        key: 'friendlyName',
        ellipsis: false,
        className: 'sec-tree-permissions-table-role-col',
        onHeaderCell: () => ({ className: 'sec-tree-permissions-table-role-col' }),
        onCell: () => ({ className: 'sec-tree-permissions-table-role-col' })
      },
      ...list.map((item: string) => ({
        title: securableTypes[item]?.name ?? item,
        key: item,
        ...toggleColumnProps,
        render: (_: unknown, role: IRoleType) =>
          renderToggleCell(
            <FormAntSwitch name={`actions.${treeItem}.${role.id}roleId.${item}`} />
          )
      }))
    ],
    [list, treeItem]
  );

  return (
    <ScrollablePermissionsTable
      className="sec-tree-permissions-table"
      size="small"
      bordered
      tableLayout="fixed"
      columns={columns}
      dataSource={roles}
      pagination={false}
      rowKey="id"
    />
  );
};

export default List;
